import { ProductOption, ProductVariant } from 'types/product'
import { FilterOption } from 'types/filters'
import { FINISHED_TO_ORDER } from '@consts/index'
import { getSortedProductOptionTypes } from './getSortedProductOptionTypes'

type GetFilteredVariantsArgs = {
  productOptions: ProductOption[]
  variant: ProductVariant
  filterOptions: FilterOption[]
}

export function isMatchingVariantForOptions({
  productOptions,
  variant,
  filterOptions
}: GetFilteredVariantsArgs) {
  const productOptionTypes = getSortedProductOptionTypes(productOptions)

  // Create a mapping of variant options for easier access
  const variantOptions: Record<string, string> =
    variant.options?.reduce(
      (obj, { type, value }) => Object.assign(obj, { [type]: value }),
      {}
    ) || {}
  const options = Object.keys(variantOptions)

  if (!options.length) return false

  return productOptionTypes.every((optionKey, i) => {
    const optionValue = variantOptions[optionKey]

    // Check if filter option does not match variant
    const filterDoesNotMatch = filterOptions.some(filter => {
      return (
        optionValue &&
        filter.type === productOptionTypes[i] &&
        filter.value !== optionValue &&
        optionValue !== FINISHED_TO_ORDER
      )
    })

    return !filterDoesNotMatch
  })
}
